// @ts-nocheck
import React from 'react';
import ComingSoonPage from './ComingSoonPage';

const PhotosPlaceholder: React.FC = () => (
  <ComingSoonPage
    title="Photos"
    description="Sell event photos and let staff upload galleries, with visibility controls."
  />
);

export default PhotosPlaceholder;
